export default "__VITE_ASSET__0cf4bf47__$_?nuxt_component=async&nuxt_component_name=SvgoCoinfaucet__"